import { render, staticRenderFns } from "./TripView.vue?vue&type=template&id=4ff5fce1&"
import script from "./TripView.vue?vue&type=script&lang=js&"
export * from "./TripView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports